<template>
  <div v-html="content"></div>
</template>
<script>
import {getUserGuide} from '@/api/scheme'
export default{
  data(){
    return{
      content:'',
    }
  },
  mounted(){
    getUserGuide().then(res=>{
      this.content=res.data.data.content
    })
  }
}
</script>
<style>
video{
  width:100vw;
}
</style>